// Modules
import React from 'react';
import PropTypes from 'prop-types';
import Select from './select';
import _ from 'lodash';
import Promise from 'bluebird';
import { alerts } from 'modules/alerts/actions';

export default class AjaxSelect extends React.Component {
  static propTypes = {
    triggerUpdate: PropTypes.any,
    onTriggerUpdate: PropTypes.func,
    onChange: PropTypes.func,
    loadOptions: PropTypes.func.isRequired,
    onChangeFullValue: PropTypes.func,
    value: PropTypes.any
  };

  constructor(props) {
    super(props);

    this.state = {};
    this.inputChange = this.inputChange.bind(this);
  }

  componentDidMount() {
    return this.inputChange(this.state.term);
  }

  componentDidUpdate(prevProps) {
    const needsUpdate = !_.isEqual(prevProps.triggerUpdate, this.props.triggerUpdate);

    if (needsUpdate) {
      // Clear the value for the field
      this.props.onChange(null);
      if (this.props.onChangeFullValue) this.props.onChangeFullValue(null);

      // Let the parent know we've cleared the value so they can set it if they want
      // For example a default agreement for a contract
      if (this.props.onTriggerUpdate) this.props.onTriggerUpdate();

      // Reload the options
      return this.inputChange(this.state.term);
    }
  }

  componentWillUnmount() {
    if (!this.updating.isCancelled()) this.updating.cancel();
  }

  inputChange(term) {
    this.setState({ loading: true, term });

    this.updating = Promise.resolve(this.props.loadOptions(term, this.props.value));

    this.updating
      .then(options => this.setState({ loading: false, options }))
      .catch(alerts.catchError);

    return term;
  }

  render() {
    const passed = _.omit(this.props, ['loadOptions']);
    const { options, loading } = this.state;

    return (
      <Select
        {...passed}

        cache={false}
        options={options}
        onInputChange={this.inputChange}
        isLoading={loading}
      />);
  }
}



// WEBPACK FOOTER //
// ./app/components/forms/inputs/ajax-select.js